import { CHAT_ATTACHMENTS_URI } from './env';
import { COLORS } from './styles';

export const INFINITE_SCROLL_LOAD_EDGE_OFFSET = 150;
export const INFINITE_SCROLL_LOADER_HEIGHT = 100;

export const MESSAGE_MAX_LENGTH = 2000;
export const IMAGE_PREVIEW_WIDTH = 300;

export const FAMILY_CHANNEL = 'familyCircle';
export const CHANNEL_NAME_SEPARATOR = ':user-';
export const GROUP_CHANNEL = 'group';
export const PRIVATE_CHANNEL = 'private';
export const SYSTEM_CHANNEL = 'system';
export const PRACTICE_CHANNEL = 'practice';
export const ACTIVITIES_CHANNEL = 'activities';
export const NOTIFICATIONS_CHANNEL = 'notifications';
export const GENERAL_ROLE = 'general';
export const PROVIDER_ROLE = 'provider';

export const MESSAGE_TYPES = {
  TEXT: 'text_message',
  NOTIFICATION: 'notification_message',
  ATTACHMENT: 'attachment_message',
  REMINDER: 'reminder',
  UPLOAD_ATTACHMENT: 'upload_attachment',
  LINK_PREVIEW: 'link_preview_message',
};

export const NOTIFICATION_TYPES = {
  PARTICIPANT_ADDED: 'participant_added',
  PARTICIPANT_REMOVED: 'participant_removed',
  PROVIDER_ASSIGNED: 'provider_assigned_to_patient',
  PROVIDER_REMOVED: 'provider_removed_from_patient',
  SYSTEM: 'opening_message',
  UPCOMING_SURVEY: 'upcoming_survey',
  ANSWERED_SURVEY: 'competed_survey',
  HEALTH_ALERT: 'health_alert',
  ASSIGN_TO_PROGRAM: 'adding_patient_to_program',
  REMOVE_FROM_PROGRAM: 'removing_patient_from_program',
  AUTO_RESPONSE: 'automated_response',
  FAMILY_MEMBER: 'family_member_assigned_to_patient',
  PRACTICE_REMOVED: 'practice_removed',
};

export const NEW_MESSAGE_ERRORS = {
  MESSAGE_LONG: 'MESSAGE_LONG',
  ATTACHMENT_MAX_SIZE: 'ATTACHMENT_MAX_SIZE',
  ATTACHMENT_NOT_ALLOWED_FORMAT: 'ATTACHMENT_NOT_ALLOWED_FORMAT',
  ATTACHMENT_MAX_NUMBER: 'ATTACHMENT_MAX_NUMBER',
};

export const MAX_ATTACHMENT_SIZE_ALLOWED = 50;

// not used right now.
export const ALLOWED_ATTACHMENT_FORMATS = [
  'text/plain',
  'text/rtf',
  'text/xml',
  'text/x-vcard',
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'video/quicktime',
  'video/mp4',
];

export const VALID_FILE_EXTENSIONS = [
  'jpg',
  'png',
  'pdf',
  'docx',
  'xlsx',
  'pptx',
  'rtf',
  'txt',
  'xml',
  'mov',
  'mp4',
  'vcf',
];

export const ICONS = {
  generalChatTab: 'chat-general',
  familyChatTab: 'chat-family',
  providersChatTab: 'chat-provider',
  activitiesChatTab: 'chat-activities',
  notificationsChatTab: 'chat-notifications',
  personalChatTab: 'chat-personal',
  groupChatTab: 'chat-group',
};

export const attachmentUrlResolver = (token, id) =>
  `${CHAT_ATTACHMENTS_URI}/show/${token}/${id}`;

export const ICON_BLOCK = {
  name: 'icon-lock',
  width: 12,
  height: 16,
  fill: COLORS.orangeCoral,
};

export const CONTEXT_CHAT_ICON = {
  name: 'context-chat',
  width: 11,
  height: 15,
  fill: COLORS.bluePrimary,
};

export const TEAM_ICON = {
  name: 'team',
  width: 16,
  height: 16,
  fill: COLORS.orangeCoral,
};

export const CHATS_FILTER_TYPES = {
  PROVIDER: 'provider',
  PATIENT: 'patient',
  SOCIAL: 'social',
  DEFAULT: 'all',
};

export const ALLOW_SOCIAL_CHAT_CREATION = false;

export const CALL_INFORMATION_TYPE = 'call_ended';

export const CALL_STATUS_TYPE = {
  END: 'end',
  MISSED: 'missed',
  REJECTED: 'rejected',
};



// WEBPACK FOOTER //
// ./src/constants/chat.js